import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/dom/getresizeobserver
 */

/* globals setTimeout, clearTimeout */
import mix from "../mix";
import global from "./global";
import Rect from "./rect";
import DomEmitterMixin from "./emittermixin";
var RESIZE_CHECK_INTERVAL = 100;
/**
 * Returns an instance of [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver).
 * In browsers that support the `ResizeObserver` API, the native observer instance is returned.
 * In other browsers, a polyfilled instance is returned instead with a compatible API.
 *
 * [Learn more](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) about the native API.
 *
 * @param {Function} callback A function called when any observed element was resized. Refer to the
 * native [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) API to
 * learn more.
 * @returns {module:utils/dom/getresizeobserver~ResizeObserver} An observer instance.
 */

export default function getResizeObserver(callback) {
  // TODO: One day, the `ResizeObserver` API will be supported in all modern web browsers.
  // When it happens, this module will no longer make sense and should be removed and
  // the native implementation should be used across the project to save bytes.
  // Check out https://caniuse.com/#feat=resizeobserver.
  if (typeof global.window.ResizeObserver === 'function') {
    return new global.window.ResizeObserver(callback);
  } else {
    return new ResizeObserverPolyfill(callback);
  }
}
/**
 * A polyfill class for the native [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver).
 *
 * @private
 * @mixes module:utils/domemittermixin~DomEmitterMixin
 */

var ResizeObserverPolyfill = /*#__PURE__*/function () {
  /**
   * Creates an instance of the {@link module:utils/dom/getresizeobserver~ResizeObserverPolyfill} class.
   *
   * It synchronously reacts to resize of the window to check if observed elements' geometry changed.
   *
   * Additionally, the polyfilled observer uses a timeout to check if observed elements' geometry has changed
   * in some other way (dynamic layouts, scrollbars showing up, etc.), so its response can also be asynchronous.
   *
   * @param {Function} callback A function called when any observed element was resized. Refer to the
   * native [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) API to
   * learn more.
   */
  function ResizeObserverPolyfill(callback) {
    _classCallCheck(this, ResizeObserverPolyfill);

    /**
     * A function called when any observed {@link #_elements element} was resized.
     *
     * @readonly
     * @protected
     * @member {Function}
     */
    this._callback = callback;
    /**
     * DOM elements currently observed by the observer instance.
     *
     * @readonly
     * @protected
     * @member {Set}
     */

    this._elements = new Set();
    /**
     * Cached DOM {@link #_elements elements} bounding rects to compare to upon the next check.
     *
     * @readonly
     * @protected
     * @member {Map.<HTMLElement,module:utils/dom/rect~Rect>}
     */

    this._previousRects = new Map();
    /**
     * An UID of the current timeout upon which the observed elements rects
     * will be compared to the {@link #_previousRects previous rects} from the past.
     *
     * @readonly
     * @protected
     * @member {Map.<HTMLElement,module:utils/dom/rect~Rect>}
     */

    this._periodicCheckTimeout = null;
  }
  /**
   * Starts observing a DOM element.
   *
   * Learn more in the
   * [native method documentation](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/observe).
   *
   * @param {HTMLElement} element
   */


  _createClass(ResizeObserverPolyfill, [{
    key: "observe",
    value: function observe(element) {
      this._elements.add(element);

      if (this._elements.size === 1) {
        this._startPeriodicCheck();
      }
    }
    /**
     * Stops observing a DOM element.
     *
     * Learn more in the
     * [native method documentation](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/unobserve).
     *
     * @param {HTMLElement} element
     */

  }, {
    key: "unobserve",
    value: function unobserve(element) {
      this._elements.delete(element);

      this._previousRects.delete(element);

      if (!this._elements.size) {
        this._stopPeriodicCheck();
      }
    }
    /**
     * Stops observing all observed DOM elements.
     *
     * Learn more in the
     * [native method documentation](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/disconnect).
     *
     * @param {HTMLElement} element
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this = this;

      this._elements.forEach(function (element) {
        return _this.unobserve(element);
      });
    }
    /**
     * When called, the observer calls the {@link #_callback resize callback} for all observed
     * {@link #_elements elements} but also starts checking periodically for changes in the elements' geometry.
     * If some are detected, {@link #_callback resize callback} is called for relevant elements that were resized.
     *
     * @protected
     */

  }, {
    key: "_startPeriodicCheck",
    value: function _startPeriodicCheck() {
      var _this2 = this;

      var periodicCheck = function periodicCheck() {
        _this2._checkElementRectsAndExecuteCallback();

        _this2._periodicCheckTimeout = setTimeout(periodicCheck, RESIZE_CHECK_INTERVAL);
      };

      this.listenTo(global.window, 'resize', function () {
        _this2._checkElementRectsAndExecuteCallback();
      });
      periodicCheck();
    }
    /**
     * Stops checking for changes in all observed {@link #_elements elements} geometry.
     *
     * @protected
     */

  }, {
    key: "_stopPeriodicCheck",
    value: function _stopPeriodicCheck() {
      clearTimeout(this._periodicCheckTimeout);
      this.stopListening();

      this._previousRects.clear();
    }
    /**
     * Checks if the geometry of any of the {@link #_elements element} has changed. If so, executes
     * the {@link #_callback resize callback} with element geometry data.
     *
     * @protected
     */

  }, {
    key: "_checkElementRectsAndExecuteCallback",
    value: function _checkElementRectsAndExecuteCallback() {
      var entries = [];

      var _iterator = _createForOfIteratorHelper(this._elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          if (this._hasRectChanged(element)) {
            entries.push({
              target: element,
              contentRect: this._previousRects.get(element)
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (entries.length) {
        this._callback(entries);
      }
    }
    /**
     * Compares the DOM element geometry to the {@link #_previousRects cached geometry} from the past.
     * Returns `true` if geometry has changed or the element is checked for the first time.
     *
     * @protected
     * @param {HTMLElement} element
     * @returns {Boolean}
     */

  }, {
    key: "_hasRectChanged",
    value: function _hasRectChanged(element) {
      if (!element.ownerDocument.body.contains(element)) {
        return false;
      }

      var currentRect = new Rect(element);

      var previousRect = this._previousRects.get(element); // The first check should always yield true despite no Previous rect to compare to.
      // The native ResizeObserver does that and... that makes sense. Sort of.


      var hasChanged = !previousRect || !previousRect.isEqual(currentRect);

      this._previousRects.set(element, currentRect);

      return hasChanged;
    }
  }]);

  return ResizeObserverPolyfill;
}();

mix(ResizeObserverPolyfill, DomEmitterMixin);
/**
 * A resize observer object (either native or {@link module:utils/dom/getresizeobserver~getResizeObserver polyfilled})
 * offering the [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) API.
 *
 * @typedef {Function} module:utils/dom/getresizeobserver~ResizeObserver
 */